import React, { useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import GamicRow from './GamicRow';
import { AdminGamic } from '../types';
import GamicsDialog from '@/components/dialog/GamicsDialog';

interface Props {
  data: AdminGamic[];
  loadMore: () => void;
  hasMore: boolean;
}

const colWidths = [
  'min-w-[56px]',
  'min-w-[160px]',
  'min-w-[150px]',
  'min-w-[100px]',
  'min-w-[130px]',
  'min-w-[100px]',
  'min-w-[104px]',
  'min-w-[48px]',
];

const headers = [
  'Image',
  'Timestamp',
  'Gamic Title',
  'Category',
  'Download Link',
  'Console Result',
  'Gamics',
  'Action',
];

const GamicsTable: React.FC<Props> = ({ data, loadMore, hasMore }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogType, setDialogType] = useState<
    'removed' | 'approved' | 'rejected' | 'hold' | 'publish' | null
  >(null);
  return (
    <div className='relative h-full'>
      <div
        id='gamic-scroll'
        className='absolute inset-0 scrollbar scrollbar-thumb-[#EEEEEE] scrollbar-track-transparent overflow-auto'
      >
        <InfiniteScroll
          dataLength={data.length}
          next={loadMore}
          hasMore={hasMore}
          loader={<div className='p-4 text-center text-sm'>Loading…</div>}
          scrollableTarget='gamic-scroll'
          className='!overflow-visible'
        >
          <table className='min-w-full  table-fixed text-left'>
            <colgroup>
              {colWidths.map((w, i) => (
                <col key={i} className={w} />
              ))}
            </colgroup>
            <thead className='sticky top-0 z-10 bg-white border-b'>
              <tr>
                {headers.map((h, i) => (
                  <th
                    key={i}
                    className={`px-4 py-[18px] font-bold whitespace-nowrap ${i === headers.length - 1 ? 'pr-[21px]' : ''}`}
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((g) => (
                <GamicRow
                  key={g.id}
                  gamic={g}
                  setDialogOpen={setDialogOpen}
                  setDialogType={setDialogType}
                />
              ))}
            </tbody>
          </table>
        </InfiniteScroll>
      </div>
      <GamicsDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        type={dialogType!}
      />
    </div>
  );
};

export default GamicsTable;
